import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSharedContactInteractionSummary } from '@reducers/sharedData/moments';
import { selectSharedContactSources } from '@reducers/sharedData/sources';
import { fetchSharedContact } from '@actions/shared/contacts';
import { fetchSharedContactMoments } from '@actions/shared/moments';
import { fetchSharedContactSources } from '@actions/shared/sources';
import { useAuthContext } from '@hooks/use-auth-context';
import { ID } from '@app/types';
import { selectSharedContact } from '@reducers/sharedData/contacts';
import { ContactPreviewSidebarDisplay } from '@components/Contact/Sidebar';

export default function SharedContactPreview({
  contactUUID,
  className,
}: {
  contactUUID?: ID;
  className?: string;
}) {
  const dispatch = useDispatch();
  const { user } = useAuthContext();
  const contact = useSelector(selectSharedContact(contactUUID));
  const sources = useSelector(selectSharedContactSources(contactUUID));
  const summary = useSelector(selectSharedContactInteractionSummary(contactUUID));

  useEffect(() => {
    if (contactUUID) {
      dispatch(fetchSharedContact(contactUUID, user));
      dispatch(fetchSharedContactMoments(contactUUID, user));
      dispatch(fetchSharedContactSources(contactUUID, user));
    }
  }, [contactUUID]);

  return (
    <ContactPreviewSidebarDisplay
      className={className}
      contact={contactUUID && contact}
      sources={sources}
      summary={summary}
    />
  );
}
